// extracted by mini-css-extract-plugin
module.exports = {"section":"SearchSeriesList__section","content":"SearchSeriesList__content"};